import AppDispatcher from '../flux/AppDispatcher';
import WebClientConstants from '../constants/WebClientConstants';
var dispatcher = AppDispatcher.get(WebClientConstants.DISPATCHER);

var SharedWebClientActions = {
    registerExportGLB(exportFunc: any) {
        dispatcher.dispatch({
            actionType: WebClientConstants.SET_EXPORT_GLB,
            getExportFunc: exportFunc,
 
        });
    },
    registerExportOBJ(exportFunc: any) {
        dispatcher.dispatch({
            actionType: WebClientConstants.SET_EXPORT_OBJ,
            getExportFunc: exportFunc,

        });
    },   
}

export default SharedWebClientActions;